import './success.css'

export function UnsubscribeSuccess() {
  return (
    <div className="success-container">
      <h1 className="success-header">Success!</h1>
      <p className="success-description">
        You have unsubscribed from MIT 2025 Commencement ceremony text notifications.
      </p>
      <p className="success-description">
        Was this a mistake? <a href="/">Resubscribe</a>
      </p>
    </div>
  )
}
